const getUrlFilePreviewFromBase64 = (content, type = 'PDF') => {
    try {
        if (!content) {
            return '';
        }
        const bytes = atob(content);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }
        let contentView = new Blob([out], { type: 'application/pdf' });
        if (type !== 'PDF') {
            contentView = new Blob([out], { type});
        }
        return URL.createObjectURL(contentView);
    } catch (error) {
        console.error('error: ', error);
    }
};

export default getUrlFilePreviewFromBase64;
